import type {
    ChargeDetail,
    OneTimeDiscountsListMeta,
    OneTimeDiscountsListParams,
    OneTimeDiscountStatus
} from '../../services/billing';

const USABLE_STATUSES: OneTimeDiscountStatus[] = ['available', 'expiring'];

export interface UsableCreditsSummary {
    count: number;
    total: number;
}

// Unlinked credits of the charge's practice owned by its patient or by no patient.
// Only the status summary is read, so one row is enough and the totals stay uncapped.
export function usableCreditsParams(
    charge: Pick<ChargeDetail, 'practiceId' | 'patientId'>
): OneTimeDiscountsListParams {
    return {
        page: 1,
        limit: 1,
        practiceId: charge.practiceId,
        patientId: charge.patientId ?? undefined,
        includeUnassigned: true,
        linked: false
    };
}

export function summarizeUsableCredits(
    statusSummary: OneTimeDiscountsListMeta['statusSummary']
): UsableCreditsSummary {
    return USABLE_STATUSES.reduce(
        (acc, status) => ({
            count: acc.count + (statusSummary?.[status]?.count ?? 0),
            total: acc.total + Number(statusSummary?.[status]?.totalAmount ?? 0)
        }),
        { count: 0, total: 0 }
    );
}
